import { render, staticRenderFns } from "./cases.vue?vue&type=template&id=7ffb5cb3"
import script from "./cases.vue?vue&type=script&lang=js"
export * from "./cases.vue?vue&type=script&lang=js"
import style0 from "./cases.vue?vue&type=style&index=0&id=7ffb5cb3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports